import client from './client';
import { getRequestData } from './index';

export default (
    marketSelections: string[],
    book: string,
    line: (string | null)[],
    region: string,
    referrer: string
) => {
    client.info('redirect to sportsbook', {
        marketSelections,
        context: 'BetPlaceStandalonePage#Redirect',
        book,
        region,
        line,
        referrer,
        ...getRequestData(),
    });
};
